module.exports = __webpack_public_path__ + "static/media/download.91feb85f.svg";